
// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import qs from 'query-string'

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
    baseQuery: fetchBaseQuery({ 
        baseUrl: process.env.REACT_APP_API_URL,
        // this serializes query string arrays in the correct format for the .NET backend
        paramsSerializer: params => qs.stringify(params) 
    }),
    endpoints: () => ({}),
})